import React from 'react';
import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';

const Root = styled('div')(({ theme }) => ({
  '& .content_container': {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      maxWidth: theme.breakpoints.values.sm,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: theme.breakpoints.values.md,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: theme.breakpoints.values.lg,
    },
  },
}));

export default function ContentContainer({
  children,
  paddingBottom = true,
  classes = '',
}) {
  return (
    <Root>
      <Container
        className={`content_container ${classes}`}
        maxWidth="lg"
        sx={{ pb: paddingBottom ? 10 : 0 }}
      >
        {children}
      </Container>
    </Root>
  );
}

// Prop Types
ContentContainer.propTypes = {
  paddingBottom: PropTypes.bool,
  children: PropTypes.node.isRequired,
  classes: PropTypes.string,
};
